module.exports = __webpack_public_path__ + "img/0030.cd343d59.png";